import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Branded, BrandLogo, PoweredBy, brandName } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

const pub = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export default function Join() {
  const { token } = useParams();
  const nav = useNavigate();
  const { adopt } = useAuth();
  const [inv, setInv] = useState(null);
  const [err, setErr] = useState("");
  const [f, setF] = useState({ name: "", password: "", phone: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { pub.get(`/public/invite/${token}`).then((r) => { setInv(r.data); setF((x) => ({ ...x, name: r.data.name || "" })); }).catch((e) => setErr(errMsg(e))); }, [token]);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try {
      const r = await pub.post(`/public/invite/${token}/accept`, { name: f.name.trim(), password: f.password, phone: f.phone.trim() || null });
      sessionStorage.setItem("ip_biz", r.data.business.slug);
      adopt(r.data.token, r.data.user);
      nav("/admin", { replace: true });
    } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };
  if (!inv && err) return <div className="login fade" data-testid="join-invalid"><h1>INVITE NOT VALID</h1><p data-testid="join-error">{err}</p><Link to="/login" className="btn" data-testid="join-signin">Sign in</Link></div>;
  if (!inv) return <div className="center"><span className="spin" /></div>;
  const brand = { ...inv.brand, studioName: inv.brand.studioName || inv.business.name };
  return (
    <Branded brand={brand}>
      <div className="login fade" data-testid="join-page">
        <div className="brand" style={{ marginBottom: 16 }}><BrandLogo brand={brand} size={34} testId="join-brand-logo" /><div><b style={{ fontSize: 16 }} data-testid="join-business-name">{brandName(brand).toUpperCase()}</b><small>COACH INVITE · POWERED BY SPOTTROS</small></div></div>
        <h1>JOIN THE TEAM</h1>
        <p data-testid="join-intro"><b>{inv.invitedBy}</b> invited <b>{inv.email}</b> to coach at {inv.business.name}. Set your name and password to get in — you'll share clients, schedule and programs with the team.</p>
        <form onSubmit={submit}>
          <label>Your name</label><input required minLength={2} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="join-name-input" />
          <label>Password (8+ chars, letter + number)</label><input required type="password" minLength={8} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="join-password-input" />
          <label>Phone (optional, for WhatsApp alerts)</label><input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="join-phone-input" />
          <div style={{ marginTop: 20 }}><button className="btn" style={{ width: "100%" }} disabled={busy} data-testid="join-submit-button">{busy ? "Joining…" : "Accept & join"}</button></div>
          {err && <div className="err" data-testid="join-error">{err}</div>}
        </form>
        <PoweredBy />
      </div>
    </Branded>
  );
}
